// extracted by mini-css-extract-plugin
export var cardContainer = "_pg-0";
export var cardHeader = "_pg-2";
export var collapsedState = "_pg-3";
export var dragHandle = "_pg-5";
export var dragHandleIcon = "_pg-6";
export var dragging = "_pg-1";
export var titleArea = "_pg-4";